import React from "react";

// Contador regressivo baseado em data final
const CountdownTimer = ({ targetDate }) => {
    const [timeLeft, setTimeLeft] = React.useState(calculateTimeLeft());
    
    React.useEffect(() => {
        const timer = setInterval(() => {
        setTimeLeft(calculateTimeLeft());
        }, 1000);
    
        return () => clearInterval(timer);
    }, [targetDate]);
    
    function calculateTimeLeft() {
        const difference = +new Date(targetDate) - +new Date();
        let timeLeft = {};
    
        if (difference > 0) {
            timeLeft = {
                // days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                // hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutos: Math.floor((difference / 1000 / 60) % 60),
                segundos: String(Math.floor((difference / 1000) % 60)).padStart(2, "0"),
            };
        } else {
            timeLeft = { dias: 0, horas: 0, minutos: 0, segundos: 0 };
        }
    
        return timeLeft;
    }
    
    return (
        <div className="countdown-timer">
        {Object.keys(timeLeft).map((interval) => (
            <span key={interval} className="time-segment">
                <strong>{timeLeft[interval]}</strong>
                {interval === "minutos" ? ":" : ""}
            </span>
        ))}
        </div>
    );
};

export default CountdownTimer;
